export const ACTIONS = {
    SESSION_CHECKED: "SESSION_CHECKED",
    SAVE_USER_SESSION: "SAVE_USER_SESSION",
    GET_PERMISSIONS_REQUESTED: 'GET_PERMISSIONS_REQUESTED',
    GET_PERMISSIONS_SUCCEEDED: 'GET_PERMISSIONS_SUCCEEDED',
    GET_PERMISSIONS_FAILED: 'GET_PERMISSIONS_FAILED'

    // Get Roles
}